'use client';

import { useSnackbarContext } from '@/components/SnackbarProvider';

/**
 * Copies text to the clipboard. Success is quiet, so whatever was clicked shows it in place; only a failure is
 * announced. Resolves whether it copied.
 */
export function useCopy() {
  const { showError } = useSnackbarContext();
  return async (text: string, what: string) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      showError(`Could not copy the ${what.toLowerCase()}`);
      return false;
    }
  };
}
